import { useState } from 'react';
import { BsShare } from 'react-icons/bs';

type ShareButtonProps = {
    title: string;
    url?: string;
    className?: string;
};

const ShareButton: React.FC<ShareButtonProps> = ({ title, url, className = '' }) => {
    const [copied, setCopied] = useState(false);

    const share = async () => {
        const shareUrl = url ? new URL(url, window.location.origin).href : window.location.href;

        if (navigator.share) {
            try {
                await navigator.share({ title, url: shareUrl });
                return;
            } catch (error) {
                if (error instanceof DOMException && error.name === 'AbortError') return;
            }
        }

        if (!navigator.clipboard) return;
        await navigator.clipboard.writeText(shareUrl);
        setCopied(true);
        window.setTimeout(() => setCopied(false), 2000);
    };

    return (
        <button
            type="button"
            onClick={share}
            className={`inline-flex items-center gap-2 rounded-md bg-primary px-4 py-2 text-white transition hover:opacity-90 ${className}`}
        >
            <BsShare aria-hidden="true" />
            {copied ? 'Lien copié' : 'Partager'}
        </button>
    );
};

export default ShareButton;
